import { styled } from 'styled-components'

export const CaptionContainer = styled.div`
  margin-top: 6px;
`
